import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SvgComponent from './SvgComponent';
import { STATIC_ROOT } from '../constants';

import './HowItWorksComponent.scss';

class HowItWorksComponent extends React.Component {
    render() {
        const { i18n, topShadow, showTitle, cssClass } = this.props;
        return (
            <section className={`cmt-ca-marche ${topShadow ? ' cmt-ca-marche-shadow' : ''}`}>
                <div className={cssClass}>
                    {showTitle && <h2>{i18n.h2}</h2>}
                    <div className="wrapper">
                        <div className="cmt-ca-marche-bloc flex-container-h">
                            <SvgComponent src={`${STATIC_ROOT}/ccm-1.svg`} width="72" height="72" />
                            <div className="texte">
                                <p>
                                    <strong>{i18n.title1}</strong>
                                    <br />
                                    {i18n.text1x1}
                                </p>
                            </div>
                        </div>
                        <div className="cmt-ca-marche-bloc flex-container-h">
                            <SvgComponent src={`${STATIC_ROOT}/ccm-2.svg`} width="72" height="72" />
                            <div className="texte">
                                <p>
                                    <strong>{i18n.title2}</strong>
                                    <br />
                                    {i18n.text2x1}
                                </p>
                            </div>
                        </div>
                        <div className="cmt-ca-marche-bloc flex-container-h">
                            <SvgComponent src={`${STATIC_ROOT}/ccm-3.svg`} width="72" height="72" />
                            <div className="texte">
                                <p>
                                    <strong>{i18n.title3}</strong>
                                    <br />
                                    {i18n.text3x1}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

HowItWorksComponent.propTypes = {
    showTitle: PropTypes.bool,
    topShadow: PropTypes.bool,
    cssClass: PropTypes.string,
    i18n: PropTypes.object.isRequired
};

const mapStoreToProps = state => ({
    i18n: state.i18n.feature.aide.commentcamarche
});

export default connect(mapStoreToProps)(HowItWorksComponent);



// WEBPACK FOOTER //
// ./src/components/HowItWorksComponent.js